import { ChartCard } from "../../../components/ChartCard";
import { FG1, MUTED } from "../../../lib/funnel/theme";
import {
  FEATURE_LABEL, FEATURE_DEFINITION, FEATURE_OUTCOME, FEATURE_ORDER,
  OVERALL_DEFINITION, OVERALL_OUTCOME,
} from "../definitions";

export function DefinitionsPanel() {
  return (
    <ChartCard
      title="How we count active users"
      subtitle="A user is active in a week if they create or send something in one of the five features below. Passive use (logging in, viewing content) is not counted."
    >
      <div style={{ display: "grid", rowGap: 20, marginTop: 12 }}>
        <DefRow label="Overall WAU" outcome={OVERALL_OUTCOME} technical={OVERALL_DEFINITION} />
        {FEATURE_ORDER.map((f) => (
          <DefRow
            key={f}
            label={FEATURE_LABEL[f]}
            outcome={FEATURE_OUTCOME[f]}
            technical={FEATURE_DEFINITION[f]}
          />
        ))}
      </div>
    </ChartCard>
  );
}

function DefRow({ label, outcome, technical }: { label: string; outcome: string; technical: string }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "140px 1fr", columnGap: 20 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: FG1 }}>{label}</div>
      <div style={{ display: "grid", rowGap: 6 }}>
        <div style={{ fontSize: 12, color: FG1, lineHeight: 1.5 }}>{outcome}</div>
        <div style={{ fontSize: 11, color: MUTED, lineHeight: 1.5 }}>{technical}</div>
      </div>
    </div>
  );
}
